// Is Send all payment texts on here (0093; docs/plans/send-all-texts/PLAN.md): the owner, texting from Roundly
// connected (/api/me texting), and the agreement said in Extra features. Its own small file, so the screens that offer
// the button read it without loading Send all itself (src/send-all-sheet.ts, loaded only when it is on).
import { getMe } from './me'
import { businessSettings, hasBusinessSettings } from './business-settings'

export function sendAllOn(): boolean {
  const me = getMe()
  // Or WhatsApp from Roundly is sending them (Stage 2): its own statement, made on the WhatsApp card, is its agreement.
  return me?.role === 'owner' && ((me.texting === true && hasBusinessSettings() && businessSettings().texts_agreed === true) || me.waSends === true)
}
